import React, { FC, useMemo } from "react";
import { Pressable } from "react-native";
import { LazyImage, useScreenSize } from "@lookiero/sty-psp-ui";
import { MediaProjection } from "../../../../../../projection/checkoutItem/checkoutItem";
import { useMediaImage } from "../../../../hooks/useMediaImage";
import { IMAGE_WIDTH, style as productVariantThumbnailStyle } from "./ProductVariantThumbnail.style";

interface ProductVariantThumbnailProps {
  readonly media: MediaProjection[];
  readonly onPress?: () => void;
  readonly testID?: string;
}
const ProductVariantThumbnail: FC<ProductVariantThumbnailProps> = ({
  media,
  onPress,
  testID = "product-variant-thumbnail",
}) => {
  const cdnImageUrl = useMediaImage();
  const screenSize = useScreenSize();
  const isDesktop = screenSize === "L";

  const style = useMemo(() => productVariantThumbnailStyle(isDesktop), [isDesktop]);

  return (
    <Pressable pointerEvents={onPress ? "auto" : "none"} style={style.container} testID={testID} onPress={onPress}>
      <LazyImage
        hiResSrc={cdnImageUrl({ url: media[0]?.url as string, width: IMAGE_WIDTH })}
        resizeMode="cover"
        src={cdnImageUrl({ url: media[0]?.url as string, width: IMAGE_WIDTH, dpi: 1 })}
        style={{ view: style.media }}
        testID="product-variant-thumbnail-media"
      />
    </Pressable>
  );
};

export type { ProductVariantThumbnailProps };
export { ProductVariantThumbnail };
